import React from 'react';
import { Phone, Mail, Star, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { SITE } from '../data/site';
import { TESTIDS } from '../constants/testIds';

export const Footer = () => {
  return (
    <footer data-testid={TESTIDS.footerSection}>
      {/* Gold contact bar */}
      <div className="bg-[#E8B842] text-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid lg:grid-cols-12 gap-6 items-center">
          <div className="lg:col-span-4">
            <div className="font-display uppercase tracking-wider text-sm">Call</div>
            <div className="font-display uppercase font-extrabold text-3xl sm:text-4xl leading-none mt-1">
              Contact Luke Today
            </div>
          </div>

          <div className="lg:col-span-5 grid sm:grid-cols-2 gap-3">
            <a
              href={SITE.emailHref}
              data-testid={TESTIDS.footerEmail}
              className="flex items-center gap-3 bg-black text-[#E8B842] px-4 py-3 hover:bg-[#1A1A1A] transition-colors"
            >
              <Mail className="w-5 h-5 shrink-0" />
              <span className="font-display uppercase tracking-wider text-xs sm:text-sm break-all">
                {SITE.email}
              </span>
            </a>
            <a
              href={SITE.phoneTel}
              data-testid={TESTIDS.footerPhone}
              className="flex items-center gap-3 bg-black text-[#E8B842] px-4 py-3 hover:bg-[#1A1A1A] transition-colors"
            >
              <Phone className="w-5 h-5 shrink-0" />
              <span className="font-display uppercase tracking-wider text-sm">
                {SITE.phoneDisplay}
              </span>
            </a>
          </div>

          <div className="lg:col-span-3 flex items-center gap-3 lg:justify-end">
            <div className="flex flex-col items-start lg:items-end">
              <div className="flex items-center gap-1.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-black text-black" />
                ))}
              </div>
              <div className="font-display uppercase tracking-widest text-xs mt-1">
                Google Reviews · 5.0
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lower footer */}
      <div className="bg-[#050505] border-t border-[#E8B842]/15">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid md:grid-cols-3 gap-8">
          <div>
            <Logo height={56} />
            <p className="mt-4 text-sm text-[#A3A3A3] max-w-xs leading-relaxed">
              Family-trusted gutter, fascia and soffit specialists serving Leamington Spa,
              Warwick, Kenilworth and surrounding villages.
            </p>
          </div>

          <div>
            <h4 className="font-display uppercase tracking-widest text-xs text-[#E8B842] mb-4">
              Services
            </h4>
            <ul className="space-y-2 text-sm text-[#C7C7C7]">
              <li>UPVC gutter, fascia & soffit replacement</li>
              <li>Leaking gutter repair</li>
              <li>Gutter moss removal</li>
              <li>Hand cleaning</li>
              <li>Roof moss removal</li>
            </ul>
          </div>

          <div>
            <h4 className="font-display uppercase tracking-widest text-xs text-[#E8B842] mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2 text-sm text-[#C7C7C7]">
              <li>
                <a href="/#services" className="hover:text-[#E8B842] transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a href="/#gallery" className="hover:text-[#E8B842] transition-colors">
                  Gallery
                </a>
              </li>
              <li>
                <a href="/#areas" className="hover:text-[#E8B842] transition-colors">
                  Service Areas
                </a>
              </li>
              <li>
                <a href="/#reviews" className="hover:text-[#E8B842] transition-colors">
                  Reviews
                </a>
              </li>
              <li>
                <Link to="/faq" className="hover:text-[#E8B842] transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/gutter-cleaning-leamington-spa"
                  className="hover:text-[#E8B842] transition-colors"
                >
                  Gutter Cleaning Leamington Spa
                </Link>
              </li>
              <li>
                <a href="/#contact" className="hover:text-[#E8B842] transition-colors">
                  Get a Quote
                </a>
              </li>
            </ul>

            <h4 className="font-display uppercase tracking-widest text-xs text-[#E8B842] mt-6 mb-3">
              Listed On
            </h4>
            <a
              href="https://yourcallpublishing.co.uk/business-directory/leamington-gutters/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-directory-link"
              className="inline-flex items-center gap-2 text-sm text-[#C7C7C7] hover:text-[#E8B842] transition-colors"
            >
              <ExternalLink className="w-3.5 h-3.5" />
              YourCall Publishing Directory
            </a>
          </div>
        </div>

        <div className="border-t border-[#1A1A1A]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
            <div className="text-xs text-[#A3A3A3]">
              © {new Date().getFullYear()} {SITE.business}. All rights reserved.
            </div>
            <div className="text-xs text-[#A3A3A3] font-display uppercase tracking-widest">
              {SITE.location} · Fully Insured · Guaranteed Work
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
